import React, { useEffect, useState } from 'react';
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Button,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import {
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from 'moment';
import {
  CANNOT_SELECT_PAST_TIME_START_TIME,
  CANNOT_SELECT_PAST_TIME_END_TIME,
  CANNOT_SELECT_FUTURE_TIME,
  CANNOT_SELECT_END_TIME_PAST_START_TIME,
  ACTIVITY_TYPES,
  DAY,
  CANNOT_SELECT_FUTURE_DATE,
  CANNOT_SELECT_END_DATE_PAST_START_DATE,
  SCHEDULE_TYPES,
  CAN_SELECT_DATE_NUMBER_UNIQUE,
  CANNOT_SELECT_DATE_SPECIAL_CHARACTER,
  CALENDAR_VIEW,
  DATE_TIME_TYPES,
  ALWAYS_ACTIVE,
  PADDING_DURATION_OPTIONS,
  SLOT_DURATION_OPTIONS,
  GENDER_OPTIONS,
} from '../../../../constants/ActivityCalendarConst';
import { DAYS, OFFER_CARDS_DROPDOWN_RECURS } from '../../../../constants/OfferConst';
import CustomSelect from '../../../../shared/form-controls/custom-select/Custom-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import {
  getDaysOfWeekFromRange,
  handleValidation,
  VALID_INTEGER,
} from '../../../../utils/formUtils';
import { isEmpty } from 'lodash';
import { RemoveCircle } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';

const Schedule = ({
  scheduleFormData,
  setScheduleForm,
  timeSlots,
  setTimeSlots,
  hasInvalidMonthDates,
  capacity,
}) => {
  const [showOverridePopup, setShowOverridePopup] = useState(false);
  const [isEditTime, setIsEditTime] = useState({
    isEdit: false,
    timeIndex: -1,
  });
  const [slotCapField, setSlotCapField] = useState({ value: '', errors: {} });
  const [lastGeneratedFromPadding, setLastGeneratedFromPadding] = useState(false);
  const [editFields, setEditFields] = useState({
    slotDuration: '',
    paddingDuration: '',
  });
  const [editError, setEditError] = useState('');
  const [deleteErrMsg, setDeleteErrMsg] = useState('');
  const [localAddPadding, setLocalAddPadding] = useState(false);
  const [localStartTime, setLocalStartTime] = useState('');
  const [localEndTime, setLocalEndTime] = useState('');
  const [draftStartTime, setDraftStartTime] = useState(scheduleFormData.startTime.value);
  const [draftEndTime, setDraftEndTime] = useState(scheduleFormData.endTime.value);

  const [localGender, setLocalGender] = useState('All');
  const [localSlotDuration, setLocalSlotDuration] = useState({
    value: '',
    errors: {},
  });
  const [localPaddingDuration, setLocalPaddingDuration] = useState({
    value: '',
    errors: {},
  });
  const [localActivityRecurrences, setLocalActivityRecurrences] = useState({
    value: '',
    errors: {},
  });
  const parsedCapacity = (raw, defaultCap = null) =>
    raw === '' || raw === null || raw === undefined ? null : Number(raw) || defaultCap;
  const HHMM_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;
  const isTimeSlotInPast = () => {
    const now = moment();
    const today = moment().format('DD-MM-YYYY');
    const startDate = scheduleFormData?.startDate?.value;
    const endDate = scheduleFormData?.endDate?.value;
    const startTime = moment(scheduleFormData?.startTime?.value, 'HH:mm');
    const endTime = moment(scheduleFormData?.endTime?.value, 'HH:mm');

    if (scheduleFormData?.availableOn?.value === 'recurring') {
      const startMoment = moment(startDate, 'DD-MM-YYYY');
      const endMoment = moment(endDate, 'DD-MM-YYYY');
      if (startMoment.isAfter(endMoment)) {
        return true;
      }
    }
    if (moment(startDate, 'DD-MM-YYYY').isSame(today, 'day')) {
      return endTime.isBefore(now);
    }

    return false;
  };
  const isStrictDDMMYYYY = (s) =>
    /^\d{2}-\d{2}-\d{4}$/.test(String(s || '')) && moment(s, 'DD-MM-YYYY', true)?.isValid();

  const ErrorList = () => (
    <div className='input-error'>
      <div className='error-message'>
        <div>Invalid Selected Date</div>
        <div className='error-items'>
          <div>a. Dates cannot contain special character.</div>
          <div>b. Dates cannot contain Decimal, Integer.</div>
          <div>c. Dates cannot contain empty values or '0'.</div>
          <div>d. Dates cannot contain invalid date.</div>
        </div>
      </div>
    </div>
  );

  const calcGap = (idx, arr = timeSlots) =>
    idx < arr.length - 1
      ? moment(arr[idx + 1].startTime, 'HH:mm').diff(moment(arr[idx].endTime, 'HH:mm'), 'minutes')
      : 0;

  const onClickEditTime = (event, slot, index) => {
    event.preventDefault();
    setDeleteErrMsg('');
    setEditError('');
    setIsEditTime({ isEdit: true, timeIndex: index });
    setSlotCapField({ value: String(slot?.capacity ?? ''), errors: {} });
    setLocalGender(slot?.gender || 'All');
    const duration = moment(slot.endTime, 'HH:mm').diff(moment(slot.startTime, 'HH:mm'), 'minutes');
    setEditFields({
      slotDuration: String(duration),
      paddingDuration: String(calcGap(index)),
    });
    if (!localAddPadding && !lastGeneratedFromPadding) {
      setDraftStartTime(slot.startTime);
      setDraftEndTime(slot.endTime);
      setScheduleForm({
        startTime: { ...scheduleFormData.startTime, errors: {} },
        endTime: { ...scheduleFormData.endTime, errors: {} },
      });
    }
  };
  const saveEditedSlot = () => {
    const slotIndex = isEditTime.timeIndex;
    const updatedSlots = [...timeSlots];
    const endTime = moment(scheduleFormData.endTime.value, 'HH:mm');
    const newStartTime = moment(updatedSlots[slotIndex].startTime, 'HH:mm');
    const newEndTime = newStartTime.clone().add(Number(editFields.slotDuration), 'minutes');
    const newPaddingMinutes = Number(editFields.paddingDuration);
    const totalWindowEnd = endTime.isSameOrBefore(moment(scheduleFormData.startTime.value, 'HH:mm'))
      ? endTime.clone().add(1, 'day')
      : endTime;

    if (newEndTime.clone().add(newPaddingMinutes, 'minutes').isAfter(totalWindowEnd)) {
      setEditError('Slot or padding cannot exceed total available time.');
      return false;
    }

    setEditError('');

    const oldEndMoment = moment(updatedSlots[slotIndex].endTime, 'HH:mm');
    updatedSlots[slotIndex] = {
      ...updatedSlots[slotIndex],
      endTime: newEndTime.format('HH:mm'),
      capacity: parsedCapacity(slotCapField.value),
      slotDuration: String(editFields.slotDuration),
      paddingDuration: String(editFields.paddingDuration),
      gender: localGender,
    };

    const oldPaddingMinutes = calcGap(slotIndex, timeSlots);
    const timelineShiftMinutes = newEndTime
      .clone()
      .add(newPaddingMinutes, 'minutes')
      .diff(oldEndMoment.clone().add(oldPaddingMinutes, 'minutes'), 'minutes');

    const projectedLastEndMoment = moment(
      updatedSlots[updatedSlots.length - 1].endTime,
      'HH:mm',
    ).add(timelineShiftMinutes, 'minutes');
    if (projectedLastEndMoment.isAfter(totalWindowEnd)) {
      setEditError('Slot or padding cannot exceed total available time.');
      return false;
    }

    if (timelineShiftMinutes !== 0) {
      for (let j = slotIndex + 1; j < updatedSlots.length; j++) {
        updatedSlots[j] = {
          ...updatedSlots[j],
          startTime: moment(updatedSlots[j].startTime, 'HH:mm')
            .add(timelineShiftMinutes, 'minutes')
            .format('HH:mm'),
          endTime: moment(updatedSlots[j].endTime, 'HH:mm')
            .add(timelineShiftMinutes, 'minutes')
            .format('HH:mm'),
          slotDuration: String(
            moment(updatedSlots[j].endTime, 'HH:mm')
              .add(timelineShiftMinutes, 'minutes')
              .diff(
                moment(updatedSlots[j].startTime, 'HH:mm').add(timelineShiftMinutes, 'minutes'),
                'minutes',
              ),
          ),
          paddingDuration: String(calcGap(j, updatedSlots)),
        };
      }
    }
    setTimeSlots(updatedSlots);
    setScheduleForm({ timeSlots: updatedSlots });
    setIsEditTime({ isEdit: false, timeIndex: -1 });
    setSlotCapField({ value: '', errors: {} });
    return true;
  };

  const [days, setDays] = useState(DAYS);
  const setTimeFormat = (time) => {
    if (time === 'all day' || time === '24*7') return time;
    return moment(time, 'HH:mm').format('hh:mm A');
  };
  const isValidHHmm = (t) => HHMM_RE?.test(t);
  const onAddTime = () => {
    const s = localAddPadding ? localStartTime : draftStartTime || '';
    const e = localAddPadding ? localEndTime : draftEndTime || '';

    if (!isValidHHmm(s) || !isValidHHmm(e)) {
      if (!localAddPadding) {
        setScheduleForm({
          startTime: {
            ...scheduleFormData.startTime,
            errors: !isValidHHmm(s) ? { message: 'Invalid time' } : {},
          },
          endTime: {
            ...scheduleFormData.endTime,
            errors: !isValidHHmm(e) ? { message: 'Invalid time' } : {},
          },
        });
      }
      return;
    }

    if (localAddPadding) {
      const startMoment = moment(s, 'HH:mm');
      const endMoment = moment(e, 'HH:mm');

      const startDate = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY');
      const endDate = moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY');
      const isMultiDay = endDate.diff(startDate, 'days') > 0;

      if (!isMultiDay && endMoment.isSameOrBefore(startMoment)) {
        return;
      }
    }

    const defaultCap = Number(capacity) || null;
    if (deleteErrMsg) setDeleteErrMsg('');
    if (isEditTime.isEdit) {
      if (lastGeneratedFromPadding) {
        if (!saveEditedSlot()) return;
      } else {
        const updated = [...timeSlots];
        updated[isEditTime.timeIndex] = {
          startTime: moment(s, 'HH:mm').format('HH:mm'),
          endTime: moment(e, 'HH:mm').format('HH:mm'),
          capacity: parsedCapacity(slotCapField.value, defaultCap),
          gender: localGender,
        };

        setTimeSlots(updated);
        setScheduleForm({ timeSlots: updated });
      }
      setIsEditTime({ isEdit: false, timeIndex: -1 });
      return;
    }
    const { startTime, endTime, addPadding } = scheduleFormData;

    if (!startTime?.value || !endTime?.value) return;

    if (!localAddPadding) {
      const firstStart = moment(s, 'HH:mm');
      const firstEnd = moment(e, 'HH:mm');

      const newSlot = {
        startTime: firstStart?.format('HH:mm'),
        endTime: firstEnd?.format('HH:mm'),
        slotDuration: '',
        paddingDuration: '',
        gender: localGender,
      };

      setScheduleForm({
        startTime: { ...scheduleFormData.startTime, value: newSlot.startTime, errors: {} },
        endTime: { ...scheduleFormData.endTime, value: newSlot.endTime, errors: {} },
      });

      if (isEditTime?.isEdit) {
        const updated = [...timeSlots];
        updated[isEditTime?.timeIndex] = {
          ...updated[isEditTime?.timeIndex],
          ...newSlot,
          capacity: parsedCapacity(slotCapField.value, defaultCap),
          gender: localGender,
        };
        setTimeSlots(updated);
        setScheduleForm({ timeSlots: updated });
      } else {
        const updated = lastGeneratedFromPadding ? [newSlot] : [...timeSlots, newSlot];
        setTimeSlots(updated);
        setScheduleForm({ timeSlots: updated });
        setLastGeneratedFromPadding(false);
      }
    } else {
      const duration = Number(localSlotDuration.value);
      const padMins = Number(localPaddingDuration.value);
      const repeats = Number(localActivityRecurrences.value) || 1;
      setScheduleForm({
        startTime: {
          ...scheduleFormData.startTime,
          value: localStartTime,
          errors: {},
        },
        endTime: {
          ...scheduleFormData.endTime,
          value: localEndTime,
          errors: {},
        },
        addPadding: {
          ...scheduleFormData.addPadding,
          value: localAddPadding,
        },
        slotDuration: {
          ...scheduleFormData.slotDuration,
          value: localSlotDuration.value,
          errors: localSlotDuration.errors,
        },
        paddingDuration: {
          ...scheduleFormData.paddingDuration,
          value: localPaddingDuration.value,
          errors: localPaddingDuration.errors,
        },
        activityRecurrences: {
          ...scheduleFormData.activityRecurrences,
          value: localActivityRecurrences.value,
          errors: localActivityRecurrences.errors,
        },
      });

      if (isEditTime?.isEdit) {
        const updated = [...timeSlots];
        updated[isEditTime?.timeIndex] = {
          ...updated[isEditTime?.timeIndex],
          capacity: parsedCapacity(slotCapField.value, defaultCap),
          gender: localGender,
        };
        setTimeSlots(updated);
        setScheduleForm({ timeSlots: updated });
      } else {
        const slots = [];
        let startMoment = moment(localStartTime, 'HH:mm');
        let endLimit = moment(localEndTime, 'HH:mm');
        const startDate = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY');
        const endDate = moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY');
        const isMultiDay = endDate.diff(startDate, 'days') > 0;

        if (isMultiDay && endLimit.isSameOrBefore(startMoment)) {
          endLimit.add(1, 'day');
        }

        for (let i = 0; i < repeats; i++) {
          const e = startMoment.clone().add(duration, 'minutes');
          if (e.isAfter(endLimit)) break;

          slots.push({
            startTime: startMoment.format('HH:mm'),
            endTime: e.format('HH:mm'),
            capacity: defaultCap,
            slotDuration: String(duration),
            paddingDuration: String(padMins),
            gender: timeSlots[i]?.gender || 'All',
          });

          startMoment = e.clone().add(padMins, 'minutes');
        }

        setTimeSlots(slots);
        setScheduleForm({ timeSlots: slots });
        setLastGeneratedFromPadding(true);
      }
    }

    setIsEditTime({ isEdit: false, timeIndex: -1 });
    setLocalGender('All');
  };

  const isMultiDayRange = () => {
    if (scheduleFormData?.availableOn?.value !== 'recurring') return false;
    const s = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY', true);
    const e = moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY', true);
    return e.diff(s, 'days') > 0;
  };

  const handleTimePickerChange = (date, value, type) => {
    if (localAddPadding && (type === 'startTime' || type === 'endTime')) {
      let hhmm = '';
      if (typeof value === 'string') {
        hhmm = HHMM_RE.test(value) ? moment(value, 'HH:mm', true).format('HH:mm') : value ?? '';
      } else if (date) {
        const m = moment(date);
        hhmm = m.isValid() ? m.format('HH:mm') : '';
      }
      if (type === 'startTime') setLocalStartTime(hhmm);
      else setLocalEndTime(hhmm);
      const shadow = { ...scheduleFormData[type], value: hhmm, errors: {} };
      handleValidation(shadow, true);
      if (shadow.errors?.validTime) shadow.errors.message = shadow.errors.validTime;

      setScheduleForm({
        [type]: { ...scheduleFormData[type], errors: { ...shadow.errors } },
      });
      return;
    }

    let hhmm = '';
    if (typeof value === 'string') {
      hhmm = HHMM_RE.test(value) ? moment(value, 'HH:mm', true).format('HH:mm') : value ?? '';
    } else if (date) {
      const m = moment(date);
      hhmm = m.isValid() ? m.format('HH:mm') : '';
    }

    if (type === 'startTime') setDraftStartTime(hhmm);
    if (type === 'endTime') setDraftEndTime(hhmm);

    const startDate = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY', true);
    const today = moment().startOf('day');
    const isOneTime = scheduleFormData?.availableOn?.value === 'oneTime';
    const endDateForCompare = isOneTime
      ? startDate
      : moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY', true);

    const isSameDate = isOneTime
      ? startDate.isSame(today, 'day')
      : startDate.isSame(endDateForCompare, 'day');

    const selectedTime = moment(hhmm, 'HH:mm', true);
    const currentStart = moment(
      type === 'startTime' ? hhmm : scheduleFormData?.startTime?.value,
      'HH:mm',
      true,
    );
    const currentEnd = moment(
      type === 'endTime' ? hhmm : scheduleFormData?.endTime?.value,
      'HH:mm',
      true,
    );

    const currTimeField = {
      ...scheduleFormData[type],
      value: hhmm,
      errors: {},
      parentStartTime: currentStart.isValid() ? currentStart.format('HH:mm') : '',
      parentEndTime: currentEnd.isValid() ? currentEnd.format('HH:mm') : '',
    };

    handleValidation(currTimeField, true);
    if (currTimeField.errors?.validTime) {
      currTimeField.errors.message = currTimeField.errors.validTime;
    }

    const now = moment();

    if (
      isSameDate &&
      selectedTime.isValid() &&
      scheduleFormData?.availableOn?.value !== ALWAYS_ACTIVE
    ) {
      if (type === 'startTime' && selectedTime.isBefore(now)) {
        currTimeField.errors.message = CANNOT_SELECT_PAST_TIME_START_TIME;
      }
      if (type === 'endTime' && selectedTime.isBefore(now)) {
        currTimeField.errors.message = CANNOT_SELECT_PAST_TIME_END_TIME;
      }
    }

    if (selectedTime.isValid() && currentStart.isValid() && currentEnd.isValid()) {
      const multiDay = isMultiDayRange();
      if (type === 'startTime') {
        if (selectedTime.isAfter(currentEnd) && !multiDay) {
          currTimeField.errors.message = CANNOT_SELECT_FUTURE_TIME;
        } else {
          scheduleFormData.endTime.errors = {};
        }
      } else if (type === 'endTime') {
        if (selectedTime.isBefore(currentStart) && !multiDay) {
          currTimeField.errors.message = CANNOT_SELECT_END_TIME_PAST_START_TIME;
        } else {
          scheduleFormData.startTime.errors = {};
        }
      }
    }

    const shouldCommitValue =
      localAddPadding || scheduleFormData?.availableOn?.value !== 'recurring';

    setScheduleForm({
      [type]: {
        ...scheduleFormData[type],
        value: shouldCommitValue ? hhmm : scheduleFormData[type].value,
        errors: { ...currTimeField.errors },
      },
    });
  };

  const handleDatePickerChange = (date, value, type) => {
    if (value === '' || value === null) {
      const cleared = { ...scheduleFormData[type], value: '', errors: {} };
      setScheduleForm({ ...scheduleFormData, [type]: cleared });
      return;
    }
    const next = {
      ...scheduleFormData[type],
      errors: { ...(scheduleFormData[type]?.errors || {}) },
    };
    if (typeof value === 'string') next.value = value;
    const raw = next?.value;
    if (raw) {
      if (!isStrictDDMMYYYY(raw)) {
        next.errors.validDate = 'Invalid date';
        setScheduleForm({ ...scheduleFormData, [type]: next });
        return;
      }
      const parsed = moment(raw, 'DD-MM-YYYY', true);
      if (parsed?.startOf('day')?.isBefore(moment()?.startOf('day'))) {
        next.errors.validDate = 'Invalid date';
        setScheduleForm({ ...scheduleFormData, [type]: next });
        return;
      }
      next.value = parsed?.format('DD-MM-YYYY');
      delete next?.errors?.validDate;
    }
    scheduleFormData.endDate.errors = {};
    scheduleFormData.startDate.errors = {};

    let currentDateField = { ...scheduleFormData[type] };
    const selectedDate = moment(value, 'DD-MM-YYYY');
    const currentData = moment().format('DD-MM-YYYY');
    const endTime = moment(scheduleFormData?.endTime?.value, 'HH:mm');
    const startTime = moment(scheduleFormData?.startTime?.value, 'HH:mm');
    currentDateField.value = value;
    if (selectedDate?.isAfter(moment(currentData, 'DD-MM-YYYY'))) {
      scheduleFormData.startTime.errors = {};
      scheduleFormData.endTime.errors = {};
    }
    if (
      scheduleFormData?.availableOn?.value !== ACTIVITY_TYPES[0] &&
      type === DATE_TIME_TYPES[2] &&
      selectedDate.isAfter(moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY'))
    ) {
      scheduleFormData.startDate.errors['message'] = CANNOT_SELECT_FUTURE_DATE;
    }
    if (
      scheduleFormData?.availableOn?.value !== ACTIVITY_TYPES[0] &&
      type === DATE_TIME_TYPES[3] &&
      selectedDate?.isBefore(moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY'))
    ) {
      scheduleFormData.endDate.errors['message'] = CANNOT_SELECT_END_DATE_PAST_START_DATE;
    }
    if (scheduleFormData?.availableOn?.value === ACTIVITY_TYPES[2]) {
      scheduleFormData.startTime.errors = {};
      const multiDay = isMultiDayRange();
      if (!multiDay && startTime?.isAfter(endTime)) {
        scheduleFormData.startTime.errors = {
          message: CANNOT_SELECT_FUTURE_TIME,
        };
      }
    }
    if (scheduleFormData?.availableOn?.value === ACTIVITY_TYPES[0]) {
      let currentTime = moment(moment().format('HH:mm'), 'HH:mm');
      if (selectedDate?.isAfter(moment(currentData, 'DD-MM-YYYY')) && endTime?.isAfter(startTime)) {
        scheduleFormData.startTime.errors = {};
      }
      if (
        selectedDate?.isSame(moment(currentData, 'DD-MM-YYYY')) &&
        startTime?.isBefore(currentTime)
      ) {
        scheduleFormData.startTime.errors = {
          message: CANNOT_SELECT_PAST_TIME_START_TIME,
        };
      }
      if (startTime?.isValid() && endTime?.isValid() && startTime.isAfter(endTime)) {
        scheduleFormData.startTime.errors = {
          message: CANNOT_SELECT_FUTURE_TIME,
        };
      }
    }

    if (scheduleFormData?.availableOn?.value === ACTIVITY_TYPES[1]) {
      let currentTime = moment(moment().format('HH:mm'), 'HH:mm');
      let currentDate = moment().format('DD-MM-YYYY');
      let allDateIsSame = false;
      if (type === DATE_TIME_TYPES[3]) {
        let startDate = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY');

        allDateIsSame =
          startDate?.isSame(moment(currentDate, 'DD-MM-YYYY')) &&
          selectedDate?.isSame(moment(currentDate, 'DD-MM-YYYY'));
      } else if (type === DATE_TIME_TYPES[2]) {
        let endDate = moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY');
        allDateIsSame =
          endDate?.isSame(moment(currentDate, 'DD-MM-YYYY')) &&
          selectedDate?.isSame(moment(currentDate, 'DD-MM-YYYY'));
      }
      const newStartDate = type === DATE_TIME_TYPES[2]
        ? selectedDate
        : moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY');
      const newEndDate = type === DATE_TIME_TYPES[3]
        ? selectedDate
        : moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY');
      const isNewMultiDay = newEndDate.diff(newStartDate, 'days') > 0;
      if (isNewMultiDay || endTime?.isAfter(startTime)) {
        scheduleFormData.startTime.errors = {};
      } else if (startTime?.isValid() && endTime?.isValid() && startTime.isAfter(endTime)) {
        scheduleFormData.startTime.errors = {
          message: CANNOT_SELECT_FUTURE_TIME,
        };
      }
      if (allDateIsSame && startTime.isBefore(currentTime)) {
        scheduleFormData.startTime.errors = {
          message: CANNOT_SELECT_PAST_TIME_START_TIME,
        };
      }
    }
    setScheduleForm({
      ...scheduleFormData,
      [type]: currentDateField,
      startTime: { ...scheduleFormData.startTime, errors: { ...scheduleFormData.startTime.errors } },
      endTime: { ...scheduleFormData.endTime, errors: { ...scheduleFormData.endTime.errors } },
    });
  };

  useEffect(() => {
    const enabled = !!scheduleFormData.addPadding?.value;
    setLocalAddPadding(enabled);
    if (!enabled) return;

    setLocalStartTime(scheduleFormData.startTime?.value || '');
    setLocalEndTime(scheduleFormData.endTime?.value || '');
    setLocalSlotDuration({
      value: scheduleFormData.slotDuration?.value || '',
      errors: scheduleFormData.slotDuration?.errors || {},
    });
    setLocalPaddingDuration({
      value: scheduleFormData.paddingDuration?.value || '',
      errors: scheduleFormData.paddingDuration?.errors || {},
    });
    setLocalActivityRecurrences({
      value: scheduleFormData.activityRecurrences?.value || '',
      errors: scheduleFormData.activityRecurrences?.errors || {},
    });
  }, [scheduleFormData.addPadding?.value]);

  useEffect(() => {
    if (!localAddPadding) return;

    setLocalStartTime(scheduleFormData.startTime?.value || '');
    setLocalEndTime(scheduleFormData.endTime?.value || '');
  }, [localAddPadding, scheduleFormData.startTime.value, scheduleFormData.endTime.value]);

  useEffect(() => {
    if (!capacity || !timeSlots?.length) return;
    const shouldUpdate = timeSlots.every((slot) => slot.capacity === undefined);
    if (!shouldUpdate) return;

    const updated = timeSlots.map((slot) => ({
      ...slot,
      capacity: slot.capacity ?? Number(capacity),
    }));

    setTimeSlots(updated);
    setScheduleForm({ timeSlots: updated });
  }, [capacity]);

  useEffect(() => {
    if (!localAddPadding) return;

    ['slotStartTime', 'slotEndTime'].forEach((field) => {
      const f = { ...scheduleFormData[field] };
      f.parentStartTime = scheduleFormData.startTime.value;
      f.parentEndTime = scheduleFormData.endTime.value;
      f.parentSlotStart = scheduleFormData.slotStartTime?.value;
      f.parentSlotEnd = scheduleFormData.slotEndTime?.value;

      handleValidation(f, true);
      setScheduleForm({ [field]: f });
    });
  }, [localAddPadding, scheduleFormData.startTime.value, scheduleFormData.endTime.value]);

  useEffect(() => {
    if (!localAddPadding) return;
    setLocalStartTime(scheduleFormData.startTime?.value || '');
    setLocalEndTime(scheduleFormData.endTime?.value || '');
  }, [localAddPadding, scheduleFormData.startTime.value, scheduleFormData.endTime.value]);

  useEffect(() => {
    if (!localAddPadding) return;

    const validate = (localState, key) => {
      const field = {
        ...scheduleFormData[key],
        value: localState.value,
        parentStartTime: localStartTime,
        parentEndTime: localEndTime,
        parentStartDate: scheduleFormData?.startDate?.value,
        parentEndDate: scheduleFormData?.endDate?.value,
        slotDuration: localSlotDuration.value,
        paddingDuration: localPaddingDuration.value,
      };
      if (field.value) handleValidation(field, true);
      return field.errors;
    };

    setLocalSlotDuration((prev) => ({
      ...prev,
      errors: validate(localSlotDuration, 'slotDuration'),
    }));
    setLocalPaddingDuration((prev) => ({
      ...prev,
      errors: validate(localPaddingDuration, 'paddingDuration'),
    }));
    setLocalActivityRecurrences((prev) => ({
      ...prev,
      errors: validate(localActivityRecurrences, 'activityRecurrences'),
    }));
  }, [
    localAddPadding,
    localStartTime,
    localEndTime,
    localSlotDuration.value,
    localPaddingDuration.value,
    localActivityRecurrences.value,
  ]);

  useEffect(() => {
    if (scheduleFormData?.recurs?.value === CALENDAR_VIEW[1]?.id?.toUpperCase()) {
      let allDays = getDaysOfWeekFromRange(
        scheduleFormData?.startDate?.value,
        scheduleFormData?.endDate?.value,
      );
      const selectedWeek = scheduleFormData?.recursWeek?.value?.map((item) =>
        item?.name?.toUpperCase() ? item?.name?.toUpperCase() : item.toUpperCase(),
      );
      const daysArray = days?.map((daysValue) => {
        const isAvailable = allDays?.includes(daysValue.id);
        const wasSelected = selectedWeek?.includes(daysValue?.name?.toUpperCase());

        return {
          ...daysValue,
          isDisable: !isAvailable,
          ischecked: wasSelected && isAvailable,
        };
      });
      setDays(daysArray);

      const enabledSelectedDays = daysArray.filter((day) => day.ischecked && !day.isDisable);
      setTimeout(() => {
        setScheduleForm({
          recursWeek: {
            ...scheduleFormData.recursWeek,
            value: enabledSelectedDays,
          },
        });
      }, 0);
    } else if (scheduleFormData?.recurs?.value === SCHEDULE_TYPES[2]) {
      isValidMonthDates();
    }
  }, [
    scheduleFormData?.recurs?.value,
    scheduleFormData?.startDate?.value,
    scheduleFormData?.endDate?.value,
  ]);

  useEffect(() => {
    if (scheduleFormData?.availableOn?.value !== ACTIVITY_TYPES[0]) {
      handleDatePickerChange();
    } else if (scheduleFormData?.availableOn?.value === ACTIVITY_TYPES[0]) {
      handleDatePickerChange('', scheduleFormData?.startDate?.value, DATE_TIME_TYPES[2]);
    }
  }, [scheduleFormData?.availableOn?.value]);

  useEffect(() => {
    const paddingEnabled = !!scheduleFormData.addPadding?.value;
    if (!paddingEnabled || !timeSlots || timeSlots.length < 2) {
      setLastGeneratedFromPadding(false);
      return;
    }

    setLastGeneratedFromPadding(true);
  }, [
    timeSlots,
    scheduleFormData.addPadding?.value,
  ]);

  useEffect(() => {
    setDraftStartTime(scheduleFormData.startTime?.value || '');
    setDraftEndTime(scheduleFormData.endTime?.value || '');
  }, [
    scheduleFormData.startTime?.value,
    scheduleFormData.endTime?.value,
    scheduleFormData.availableOn?.value,
  ]);

  const handleCheckBox = (index, cheked) => {
    days[index].ischecked = !cheked;
    let selectedDay = days?.filter((item) => item?.ischecked);
    setScheduleForm({
      recursWeek: {
        ...scheduleFormData.recursWeek,
        value: selectedDay,
      },
    });
    setDays([...days]);
  };

  const isAllNumberValid = (num, min = 0) => {
    const recurringDate = scheduleFormData?.recursMonth?.value?.split(',')?.map(Number);
    return recurringDate?.every((e) => {
      return e <= num && e > min;
    });
  };

  const isValidMonthDates = () => {
    const fromDate = moment(scheduleFormData?.startDate?.value, 'DD-MM-YYY');
    const toDate = moment(scheduleFormData?.endDate?.value, 'DD-MM-YYY');
    const monthData = [];
    let formDay = fromDate?.format('DD');
    let toDay = toDate?.format('DD');
    let isFloat = false;
    let formDataArray = scheduleFormData?.recursMonth?.value?.split(',');
    formDataArray?.forEach((element) => {
      if (!Number.isInteger(Number(element))) {
        isFloat = true;
        return;
      }
    });
    if (isFloat) {
      return true;
    }
    while (toDate > fromDate || fromDate.format('M') === toDate.format('M')) {
      monthData.push(fromDate.format('MMMM'));
      fromDate.add(1, 'month');
    }

    if (!isEmpty(scheduleFormData?.recursMonth?.value) && formDataArray?.length) {
      if (monthData?.length === 1 && !isAllNumberValid(Number(toDay), Number(formDay - 1))) {
        return true;
      }
      if (monthData?.length === 2) {
        let dataRange = [],
          isValidRang = false;
        for (
          let i = formDay;
          i <= moment(scheduleFormData?.startDate?.value, 'YYYY-MM').daysInMonth();
          i++
        ) {
          dataRange.push(i);
        }
        for (let j = 1; j <= toDay; j++) {
          if (j === dataRange[0]) {
            break;
          }
          dataRange.push(j);
        }
        for (let checkDay = 0; checkDay < formDataArray?.length; checkDay++) {
          let isDayValidRang = dataRange?.find((item) => formDataArray[checkDay] === String(item));
          if (!isDayValidRang) {
            isValidRang = true;
            break;
          }
        }
        if (isValidRang) {
          return isValidRang;
        }
      }
      if (!isAllNumberValid(31, 0)) {
        return true;
      }
    } else {
      return false;
    }
  };

  const handleDateFailed = (value) => {
    const dateList = value?.value?.split(',')?.map(Number);
    const isDuplicate = dateList?.some((element) => {
      if (dateList?.indexOf(element) !== dateList?.lastIndexOf(element)) {
        return true;
      }
      return false;
    });
    if (isDuplicate) {
      setScheduleForm({
        recursMonth: {
          ...value,
          errors: {
            required: CAN_SELECT_DATE_NUMBER_UNIQUE,
          },
        },
      });
      return;
    }
    let isValid = isValidMonthDates(value?.value);
    if (isValid) {
      setScheduleForm({
        recursMonth: {
          ...value,
          errors: {
            required: ErrorList,
          },
        },
      });
    } else {
      setScheduleForm({
        recursMonth: {
          ...value,
          errors: {},
        },
      });
    }
  };
  const isTimingLocked = isEditTime.isEdit && lastGeneratedFromPadding;
  const canEditTiming = !isTimingLocked;

  return (
    <>
      <div className='row px-3 w-100 d-flex '>
        <div className='custom-upload col-md-12'>
          <RadioGroup
            row
            aria-label={'availableOn'}
            onChange={(e) => {
              setScheduleForm({
                availableOn: {
                  ...scheduleFormData?.availableOn,
                  value: e.target.value,
                },
              });
            }}
            value={scheduleFormData?.availableOn?.value}
            name={'availableOn'}
            className='document-type mb-3'
          >

            <FormControlLabel
              value='oneTime'
              disabled={isEditTime.isEdit && lastGeneratedFromPadding}
              control={<Radio color='primary' />}
              label='One-time'
            />
            <FormControlLabel
              value='recurring'
              disabled={isEditTime.isEdit && lastGeneratedFromPadding}
              control={<Radio color='primary' />}
              label='Recurring'
            />
          </RadioGroup>
        </div>
        {['oneTime', 'recurring'].includes(scheduleFormData?.availableOn?.value) && (
          <div className='row'>
            <div className='col-md-6 mb-2'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  minDate={new Date()}
                  variant='inline'
                  margin='normal'
                  id='startDate'
                  label={
                    scheduleFormData?.availableOn?.value === 'recurring' ? 'Start Date' : 'Date'
                  }
                  className='col-md-12 mb-2'
                  format='DD-MM-YYYY'
                  required={scheduleFormData?.startDate?.validations?.includes('required')}
                  inputValue={scheduleFormData?.startDate?.value || ''}
                  onChange={(date, value) => handleDatePickerChange(date, value, 'startDate')}
                  disableMaskedInput
                  mask={null}
                  error={
                    scheduleFormData?.startDate?.errors?.required ||
                    scheduleFormData?.startDate?.errors?.validDate ||
                    scheduleFormData?.startDate?.errors?.message
                      ? true
                      : false
                  }
                  helperText={
                    scheduleFormData?.startDate?.errors?.message ||
                    scheduleFormData?.startDate?.errors?.required ||
                    scheduleFormData?.startDate?.errors?.validDate
                  }
                  disabled={!canEditTiming}
                />
              </MuiPickersUtilsProvider>
            </div>
            {scheduleFormData?.availableOn?.value === 'recurring' && (
              <div className='col-md-6 mb-2'>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDatePicker
                    minDate={new Date()}
                    variant='inline'
                    margin='normal'
                    id='endDate'
                    label='End Date'
                    className='col-md-12 mb-2'
                    format='DD-MM-YYYY'
                    required={scheduleFormData?.endDate?.validations?.includes('required')}
                    inputValue={scheduleFormData?.endDate?.value}
                    onChange={(date, value) => handleDatePickerChange(date, value, 'endDate')}
                    error={
                      scheduleFormData?.endDate?.errors?.required ||
                      scheduleFormData?.endDate?.errors?.validDate ||
                      scheduleFormData?.endDate?.errors?.message
                        ? true
                        : false
                    }
                    helperText={
                      scheduleFormData?.endDate?.errors?.message ||
                      scheduleFormData?.endDate?.errors?.required ||
                      scheduleFormData?.endDate?.errors?.validDate
                    }
                    disabled={!canEditTiming}
                  />
                </MuiPickersUtilsProvider>
              </div>
            )}
          </div>
        )}
        {scheduleFormData?.availableOn?.value === 'recurring' && (
          <>
            <div className='row'>
              <div className='col-md-6 mb-2'>
                <CustomSelect
                  item={scheduleFormData?.recurs}
                  handleInputChange={(value) => {
                    setScheduleForm({ recurs: value });
                  }}
                  labelField='name'
                  valueField='id'
                  options={OFFER_CARDS_DROPDOWN_RECURS}
                  hideNullOption={true}
                  disabled={!canEditTiming}
                />
              </div>
            </div>
            {scheduleFormData?.recurs?.value === 'WEEK' && (
              <div className='custom-upload mb-2 col-md-12'>
                {days &&
                  days?.length &&
                  days?.map((dayKey, dayNdx) => (
                    <FormControlLabel
                      className='document-type pe-3'
                      key={dayKey?.id}
                      control={
                        <Checkbox
                          color='primary'
                          checked={dayKey?.ischecked}
                          onChange={(e) => {
                            handleCheckBox(dayNdx, dayKey?.ischecked);
                          }}
                          name='days'
                          disabled={dayKey.isDisable || !canEditTiming}
                        />
                      }
                      label={dayKey?.name}
                    />
                  ))}
              </div>
            )}
            {scheduleFormData?.recurs?.value === 'MONTH' && (
              <>
                <div className='row align-items-center'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={scheduleFormData?.recursMonth}
                      handleInputChange={(e) => {
                        setScheduleForm({ recursMonth: e });
                      }}
                      label='Dates of month in numerical(Separated by commas)'
                      disabled={!canEditTiming}
                    />
                  </div>
                  <div className='col-md-3 d-flex align-items-center'>(Example: 5, 15, 20)</div>
                </div>
                {isValidMonthDates() && <ErrorList />}
              </>
            )}
          </>
        )}

        {scheduleFormData?.availableOn?.value !== 'alwaysActive' && (
          <div className='row'>
            <div className='col-md-6 mb-2'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id={'startTime'}
                  label={scheduleFormData?.startTime?.fieldName}
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={scheduleFormData?.startTime?.validations?.includes('required')}
                  inputValue={localAddPadding ? localStartTime : draftStartTime}
                  onChange={(date, value) => {
                    handleTimePickerChange(date, value, 'startTime');
                  }}
                  error={
                    scheduleFormData?.startTime?.errors?.required ||
                    scheduleFormData?.startTime?.errors?.message
                      ? true
                      : false
                  }
                  helperText={
                    scheduleFormData?.startTime?.errors?.message ||
                    scheduleFormData?.startTime?.errors?.required ||
                    (scheduleFormData.availableOn.value === 'recurring' &&
                    scheduleFormData.addPadding?.value
                      ? 'Choose start and end times to set total hours, then define activity slots with padding.'
                      : '')
                  }
                  keyboardIcon={<AccessTimeIcon />}
                  disabled={!canEditTiming}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className='col-md-6 mb-2'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id={scheduleFormData?.endTime?.fieldName}
                  label={scheduleFormData?.endTime?.fieldName}
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={scheduleFormData?.endTime?.validations.includes('required')}
                  inputValue={localAddPadding ? localEndTime : draftEndTime}
                  onChange={(date, value) => {
                    handleTimePickerChange(date, value, 'endTime');
                  }}
                  error={
                    scheduleFormData?.endTime?.errors?.required ||
                    scheduleFormData?.endTime?.errors?.message
                      ? true
                      : false
                  }
                  helperText={
                    scheduleFormData?.endTime?.errors?.message ||
                    scheduleFormData?.endTime?.errors?.required
                  }
                  keyboardIcon={<AccessTimeIcon />}
                  disabled={!canEditTiming}
                />
              </MuiPickersUtilsProvider>
            </div>
            {scheduleFormData?.availableOn?.value === 'recurring' && (
              <div className='col-md-12 mb-2 d-flex align-items-center'>
                <FormControlLabel
                  control={
                    <Checkbox
                      color='primary'
                      checked={scheduleFormData?.totalActivityTime?.value || false}
                      onChange={(e) => {
                        const isChecked = e?.target?.checked;
                        if (isChecked) {
                          if (timeSlots && timeSlots.length > 0 && (localAddPadding || scheduleFormData.addPadding?.value)) {
                            setShowOverridePopup(true);
                            return;
                          }
                          setLocalAddPadding(false);
                          setTimeSlots([]);
                          setScheduleForm({
                            totalActivityTime: {
                              ...scheduleFormData.totalActivityTime,
                              value: isChecked,
                            },
                            addPadding: { ...scheduleFormData.addPadding, value: false },
                            timeSlots: [],
                          });
                        } else {
                          setScheduleForm({
                            totalActivityTime: {
                              ...scheduleFormData.totalActivityTime,
                              value: isChecked,
                            },
                          });
                        }
                      }}
                    />
                  }
                  label='Total Activity Time'
                  style={{ color: '#828282' }}
                  disabled={!canEditTiming}
                />
                <Tooltip
                  title='Checking this will make the start & end time as the total activity duration'
                  placement='right'
                >
                  <InfoIcon fontSize='small' className='ms-1' />
                </Tooltip>
              </div>
            )}

            {scheduleFormData?.availableOn?.value === 'recurring' &&
              !scheduleFormData?.totalActivityTime?.value && (
              <div className='col-md-12 mb-2 d-flex align-items-center'>
                <FormControlLabel
                  control={
                    <Checkbox
                      color='primary'
                      checked={localAddPadding}
                      onChange={(e) => {
                        const isChecked = e?.target?.checked;

                        setLocalAddPadding(isChecked);

                        if (!isChecked) {
                          setTimeSlots([]);
                          setScheduleForm({
                            addPadding: { ...scheduleFormData.addPadding, value: false },
                            slotDuration: {
                              ...scheduleFormData.slotDuration,
                              value: '',
                              validations: [],
                              errors: {},
                            },
                            paddingDuration: {
                              ...scheduleFormData.paddingDuration,
                              value: '',
                              validations: [],
                              errors: {},
                            },
                            activityRecurrences: {
                              ...scheduleFormData.activityRecurrences,
                              value: '',
                              validations: [],
                              errors: {},
                            },
                            timeSlots: [],
                          });

                          setLocalSlotDuration({ value: '', errors: {} });
                          setLocalPaddingDuration({ value: '', errors: {} });
                          setLocalActivityRecurrences({ value: '', errors: {} });
                        } else {
                          const start = draftStartTime || scheduleFormData.startTime.value || '';
                          const end = draftEndTime || scheduleFormData.endTime.value || '';
                          setLocalStartTime(start);
                          setLocalEndTime(end);
                          setLocalSlotDuration({ value: '', errors: {} });
                          setLocalPaddingDuration({ value: '', errors: {} });
                          setLocalActivityRecurrences({ value: '', errors: {} });
                          setScheduleForm({
                            addPadding: { ...scheduleFormData.addPadding, value: true },
                            startTime: { ...scheduleFormData.startTime, value: start, errors: {} },
                            endTime: { ...scheduleFormData.endTime, value: end, errors: {} },
                            slotDuration: {
                              ...scheduleFormData.slotDuration,
                              value: '',
                              errors: {},
                              validations: ['required', 'durationWithinRange'],
                            },
                            paddingDuration: {
                              ...scheduleFormData.paddingDuration,
                              value: '',
                              errors: {},
                              validations: ['required', 'durationWithinRange'],
                            },
                            activityRecurrences: {
                              ...scheduleFormData.activityRecurrences,
                              value: '',
                              errors: {},
                              validations: ['required', 'minimumTwo', 'recurrencesWithinRange'],
                            },
                          });
                        }
                      }}
                    />
                  }
                  label='Add Padding'
                  style={{ color: '#828282' }}
                  disabled={!canEditTiming}
                />
                <Tooltip
                  title='Padding allows a free time slot between two consecutive activities'
                  placement='right'
                >
                  <InfoIcon fontSize='small' className='ms-1' />
                </Tooltip>
              </div>
            )}

            {scheduleFormData?.availableOn?.value === 'recurring' && localAddPadding && !scheduleFormData?.totalActivityTime?.value && (
              <div className='row'>
                <div className='col-md-6 mb-2'>
                  <CustomSelect
                    item={{
                      ...scheduleFormData.slotDuration,
                      value: localSlotDuration.value,
                      errors: localSlotDuration.errors,
                    }}
                    handleInputChange={(val) => {
                      const sd = {
                        ...val,
                        parentStartTime: localAddPadding
                          ? localStartTime
                          : scheduleFormData.startTime.value,
                        parentEndTime: localAddPadding
                          ? localEndTime
                          : scheduleFormData.endTime.value,
                        slotDuration: val.value,
                        paddingDuration: localPaddingDuration.value,
                      };
                      handleValidation(sd, true);
                      setLocalSlotDuration({ value: val.value, errors: sd.errors });
                    }}
                    labelField='name'
                    valueField='id'
                    options={SLOT_DURATION_OPTIONS}
                    hideNullOption
                    disabled={!canEditTiming}
                  />
                </div>

                <div className='col-md-6 mb-2'>
                  <CustomSelect
                    item={{
                      ...scheduleFormData.paddingDuration,
                      value: localPaddingDuration.value,
                      errors: localPaddingDuration.errors,
                    }}
                    handleInputChange={(val) => {
                      const pd = {
                        ...val,
                        parentStartTime: localAddPadding
                          ? localStartTime
                          : scheduleFormData.startTime.value,
                        parentEndTime: localAddPadding
                          ? localEndTime
                          : scheduleFormData.endTime.value,
                        slotDuration: localSlotDuration.value,
                        paddingDuration: val.value,
                      };
                      handleValidation(pd, true);
                      setLocalPaddingDuration({ value: val.value, errors: pd.errors });
                    }}
                    labelField='name'
                    valueField='id'
                    options={PADDING_DURATION_OPTIONS}
                    hideNullOption
                    disabled={!canEditTiming}
                  />
                </div>

                <div style={{ marginTop: '3px' }} className='col-md-6 mb-2'>
                  <CustomTextField
                    item={{
                      ...scheduleFormData.activityRecurrences,
                      value: localActivityRecurrences.value,
                      errors: localActivityRecurrences.errors,
                    }}
                    handleInputChange={(val) => {
                      const recField = {
                        ...val,
                        parentStartTime: localAddPadding
                          ? localStartTime
                          : scheduleFormData.startTime.value,
                        parentEndTime: localAddPadding
                          ? localEndTime
                          : scheduleFormData.endTime.value,
                        slotDuration: localSlotDuration.value,
                        paddingDuration: localPaddingDuration.value,
                      };

                      handleValidation(recField, true);
                      setLocalActivityRecurrences({ value: val.value, errors: recField.errors });
                    }}
                    type='number'
                    label='Activity Recurrences'
                    min={0}
                    max={99999999}
                    stripZeroOnSpinner
                    disabled={!canEditTiming}
                  />
                </div>
              </div>
            )}

            {scheduleFormData?.availableOn?.value === 'recurring' && !scheduleFormData?.totalActivityTime?.value && (
              <>
                <div className='col-md-12 mt-1'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={onAddTime}
                    size='large'
                    disabled={
                      (isEditTime.isEdit && lastGeneratedFromPadding) ||
                      scheduleFormData?.availableOn?.value === 'alwaysActive' ||
                      isTimeSlotInPast() ||
                      (localAddPadding
                        ? !localStartTime ||
                          !localEndTime ||
                          !HHMM_RE.test(localStartTime) ||
                          !HHMM_RE.test(localEndTime) ||
                          (moment(localEndTime, 'HH:mm').isSameOrBefore(
                            moment(localStartTime, 'HH:mm'),
                          ) &&
                            moment(scheduleFormData?.startDate?.value, 'DD-MM-YYYY').isSame(
                              moment(scheduleFormData?.endDate?.value, 'DD-MM-YYYY'),
                            ))
                        : !!scheduleFormData?.startTime?.errors?.message ||
                          !!scheduleFormData?.endTime?.errors?.message) ||
                      !!scheduleFormData?.startDate?.errors?.message ||
                      !!scheduleFormData?.endDate?.errors?.message ||
                      (scheduleFormData?.availableOn?.value === 'recurring' &&
                        !scheduleFormData?.recurs?.value) ||
                      (scheduleFormData?.recurs?.value === 'MONTH' &&
                        (!scheduleFormData?.recursMonth?.value?.trim() ||
                          !!scheduleFormData?.recursMonth?.errors?.required)) ||
                      (scheduleFormData?.recurs?.value === 'WEEK' &&
                        days?.filter((day) => day?.ischecked)?.length === 0) ||
                      hasInvalidMonthDates() ||
                      (localAddPadding &&
                        (!localSlotDuration.value ||
                          Object.values(localSlotDuration.errors || {}).some(Boolean) ||
                          !localPaddingDuration.value ||
                          Object.values(localPaddingDuration.errors || {}).some(Boolean) ||
                          !localActivityRecurrences.value ||
                          Object.values(localActivityRecurrences.errors || {}).some(Boolean))) ||
                      (isEditTime?.isEdit &&
                        lastGeneratedFromPadding &&
                        slotCapField.value !== '' &&
                        (Number(slotCapField.value) === 0 || !!slotCapField.errors[VALID_INTEGER]))
                    }
                    style={{
                      borderRadius: '2px !important',
                      width: '86px',
                      height: '40px',
                    }}
                  >
                    Add
                  </Button>
                </div>
                {timeSlots && timeSlots.length > 0 && (
                  <div className='col-md-12 mt-4'>
                    {timeSlots.map((slot, index) => {
                      const isLastSlot = index === timeSlots.length - 1;
                      const isEditorActive = isEditTime.isEdit && isEditTime.timeIndex === index;
                      const gap =
                        index < timeSlots.length - 1
                          ? moment(timeSlots[index + 1].startTime, 'HH:mm').diff(
                              moment(slot.endTime, 'HH:mm'),
                              'minutes',
                            )
                          : 0;

                      return (
                        <React.Fragment key={index}>
                          <div className='custom-daytime-box py-2 px-4 mb-3'>
                            <div className='d-flex justify-content-between flex-wrap'>
                              <div className='d-flex align-items-center flex-wrap'>
                                <span>
                                  {setTimeFormat(slot.startTime)} – {setTimeFormat(slot.endTime)}
                                </span>
                                {slot.capacity && (
                                  <span className='ms-2'>| Capacity - {slot.capacity}</span>
                                )}
                                {slot.gender && !isEditorActive && (
                                  <span className='ms-2'>| {slot.gender}</span>
                                )}
                                {!lastGeneratedFromPadding && isEditorActive && (
                                  <span className='ms-4' style={{ minWidth: 120 }}>
                                    <CustomSelect
                                      item={{
                                        fieldName: 'Gender',
                                        value: localGender,
                                        errors: {},
                                        validations: [],
                                      }}
                                      handleInputChange={(val) => {
                                        setLocalGender(val.value);
                                      }}
                                      labelField='name'
                                      valueField='id'
                                      options={GENDER_OPTIONS}
                                      hideNullOption
                                      style={{ minWidth: 120 }}
                                    />
                                  </span>
                                )}
                              </div>

                              <div>
                                {!isEditorActive && (
                                  <IconButton
                                    aria-label='edit'
                                    disabled={isEditTime.isEdit}
                                    onClick={(e) => onClickEditTime(e, slot, index)}
                                  >
                                    <EditIcon fontSize='small' />
                                  </IconButton>
                                )}
                                <IconButton
                                  aria-label='delete'
                                  disabled={isEditTime.isEdit}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const updated = timeSlots.filter((_, i) => i !== index);
                                    const isPaddingMode =
                                      localAddPadding ||
                                      lastGeneratedFromPadding ||
                                      scheduleFormData.addPadding?.value;
                                    if (isPaddingMode && updated.length < 2) {
                                      const dummy = {
                                        fieldName: 'Recurrences',
                                        value: updated.length,
                                        validations: ['minimumTwo'],
                                        errors: {},
                                      };
                                      handleValidation(dummy, true);
                                      setDeleteErrMsg(dummy.errors.minimumTwo);
                                      return;
                                    }
                                    setDeleteErrMsg('');
                                    const recalc = updated.map((slot, i, arr) => ({
                                      ...slot,
                                      paddingDuration:
                                        i < arr.length - 1
                                          ? String(
                                              moment(arr[i + 1].startTime, 'HH:mm').diff(
                                                moment(slot.endTime, 'HH:mm'),
                                                'minutes',
                                              ),
                                            )
                                          : slot.paddingDuration,
                                    }));
                                    setTimeSlots(recalc);
                                    setScheduleForm({ ...scheduleFormData, timeSlots: recalc });
                                  }}
                                >
                                  <RemoveCircle fontSize='small' />
                                </IconButton>
                              </div>
                            </div>

                            {!lastGeneratedFromPadding && isEditorActive && (
                              <div className='d-flex gap-2 mt-3'>
                                <Button
                                  variant='contained'
                                  color='primary'
                                  size='small'
                                  onClick={onAddTime}
                                >
                                  Save
                                </Button>
                                <Button
                                  variant='outlined'
                                  color='secondary'
                                  size='small'
                                  onClick={() => {
                                    setIsEditTime({ isEdit: false, timeIndex: -1 });
                                    setLocalGender('All');
                                  }}
                                >
                                  Cancel
                                </Button>
                              </div>
                            )}

                            {lastGeneratedFromPadding && isEditorActive && (
                              <>
                                <div className='d-flex align-items-start gap-3 mt-3 flex-nowrap'>
                                  <CustomTextField
                                    item={{
                                      fieldName: 'Capacity',
                                      value: slotCapField.value,
                                      errors: slotCapField.errors,
                                      validations: [VALID_INTEGER],
                                    }}
                                    type='number'
                                    min={1}
                                    label='Capacity'
                                    stripZeroOnSpinner
                                    handleInputChange={(obj) => {
                                      const capacityField = {
                                        fieldName: 'Capacity',
                                        value: obj.value,
                                        errors: {},
                                        validations: [VALID_INTEGER],
                                      };
                                      handleValidation(capacityField, true);
                                      setSlotCapField(capacityField);
                                    }}
                                    error={
                                      !!slotCapField.errors[VALID_INTEGER] ||
                                      (slotCapField.value !== '' &&
                                        slotCapField.value != null &&
                                        Number(slotCapField.value) === 0)
                                    }
                                    helperText={
                                      slotCapField.errors[VALID_INTEGER] ||
                                      (slotCapField.value !== '' &&
                                      slotCapField.value != null &&
                                      Number(slotCapField.value) === 0
                                        ? 'Capacity cannot be 0'
                                        : '')
                                    }
                                    style={{ width: 110 }}
                                  />

                                  <CustomSelect
                                    item={{
                                      ...scheduleFormData.slotDuration,
                                      value: editFields.slotDuration,
                                      errors: {},
                                    }}
                                    handleInputChange={(val) => {
                                      setEditFields((f) => ({ ...f, slotDuration: val.value }));
                                    }}
                                    labelField='name'
                                    valueField='id'
                                    options={SLOT_DURATION_OPTIONS}
                                    hideNullOption
                                    // className='flex-shrink-0'
                                    style={{ minWidth: 140 }}
                                  />

                                  {!isLastSlot && (
                                    <CustomSelect
                                      item={{
                                        ...scheduleFormData.paddingDuration,
                                        value: editFields.paddingDuration,
                                        errors: {},
                                      }}
                                      handleInputChange={(val) => {
                                        setEditFields((f) => ({
                                          ...f,
                                          paddingDuration: val.value,
                                        }));
                                      }}
                                      labelField='name'
                                      valueField='id'
                                      options={PADDING_DURATION_OPTIONS}
                                      hideNullOption
                                      // className='flex-shrink-0'
                                      style={{ minWidth: 150 }}
                                    />
                                  )}

                                  <CustomSelect
                                    item={{
                                      fieldName: 'Gender',
                                      value: localGender,
                                      errors: {},
                                      validations: [],
                                    }}
                                    handleInputChange={(val) => {
                                      setLocalGender(val.value);
                                    }}
                                    labelField='name'
                                    valueField='id'
                                    options={GENDER_OPTIONS}
                                    hideNullOption
                                    style={{ minWidth: 120 }}
                                  />
                                </div>
                                <div className='d-flex gap-2 mt-3'>
                                  <Button
                                    variant='contained'
                                    color='primary'
                                    size='small'
                                    onClick={onAddTime}
                                    disabled={
                                      !editFields.slotDuration ||
                                      (!isLastSlot && editFields.paddingDuration === '') ||
                                      !!slotCapField.errors[VALID_INTEGER] ||
                                      (slotCapField.value !== '' &&
                                        slotCapField.value != null &&
                                        Number(slotCapField.value) === 0)
                                    }
                                  >
                                    Save
                                  </Button>
                                  <Button
                                    variant='outlined'
                                    color='secondary'
                                    size='small'
                                    onClick={() => {
                                      setIsEditTime({ isEdit: false, timeIndex: -1 });
                                      setSlotCapField({ value: '', errors: {} });
                                      setLocalGender('All');
                                      setEditError('');
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </div>
                                {editError && (
                                  <div className='text-danger small mt-2'>{editError}</div>
                                )}
                              </>
                            )}
                          </div>
                          {index === timeSlots.length - 1 && deleteErrMsg && (
                            <div className='text-danger small mt-1'>{deleteErrMsg}</div>
                          )}

                          {lastGeneratedFromPadding &&
                            gap > 0 &&
                            index < timeSlots.length - 1 &&
                            !isEditorActive && (
                              <div className='w-50 mx-auto d-flex align-items-center justify-content-center my-2 px-3 '>
                                <hr
                                  className='flex-grow-1 border-0 border-top border-primary m-0 opacity-75'
                                  style={{ height: 0 }}
                                />
                                <span className='mx-2 fw-bold'>{gap} minutes</span>
                                <hr
                                  className='flex-grow-1 border-0 border-top border-primary m-0 opacity-75'
                                  style={{ height: 0 }}
                                />
                              </div>
                            )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <DeletePopupModel
        deletePopUp={{
          status: showOverridePopup,
          title: 'Override Padded slots',
          name: '',
          description: 'Enabling "Total Activity Time" will override all configured slots and padding for this schedule',
        }}
        inlineTitle={true}
        actionButtonText="Save"
        onDeleteCancel={() => setShowOverridePopup(false)}
        onDelete={() => {
          setLocalAddPadding(false);
          setTimeSlots([]);
          setScheduleForm({
            totalActivityTime: {
              ...scheduleFormData.totalActivityTime,
              value: true,
            },
            addPadding: { ...scheduleFormData.addPadding, value: false },
            timeSlots: [],
          });
          setShowOverridePopup(false);
        }}
      />
    </>
  );
};

export default Schedule;
